// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { deviceId } from './Device';
import { operatorId } from './Operator';
import { z } from 'zod';
export const deviceSetpointDesiredName = z.string();
export const deviceSetpointDesired = z.object({
    device_id: deviceId,
    name: deviceSetpointDesiredName,
    value: z.number(),
    updated_at: z.date(),
    updated_by: operatorId.nullable(),
});
export const deviceSetpointDesiredInitializer = z.object({
    device_id: deviceId,
    name: deviceSetpointDesiredName,
    value: z.number(),
    updated_at: z.date().optional(),
    updated_by: operatorId.optional().nullable(),
});
export const deviceSetpointDesiredMutator = z.object({
    device_id: deviceId.optional(),
    name: deviceSetpointDesiredName.optional(),
    value: z.number().optional(),
    updated_at: z.date().optional(),
    updated_by: operatorId.optional().nullable(),
});
//# sourceMappingURL=DeviceSetpointDesired.js.map